import { createRef, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import { createToastMessage, setLoading } from "../../store";
import i18n from "../../i18n";
import unsubscriptionApi from "../../api/email_unsubscriptions";
import Alert from "../Alert.jsx";
import CheckboxGroup from "../CheckboxGroup.jsx";
import SubmitButton from "../SubmitButton.jsx";
import { getRouteQueryParams } from "../../helpers";

export default function NotificationsTab(props) {
  const formRef = createRef();
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const [groups, setGroups] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [values, setValues] = useState([]);
  const [loadedValues, setLoadedValues] = useState([]);

  useEffect(async () => {
    dispatch(setLoading(true));
    updateAfterLoad(await unsubscriptionApi.fetch());

    checkUnsubscription();

    dispatch(setLoading(false));
  }, []);

  async function checkUnsubscription() {
    const params = getRouteQueryParams(window.location.href);
    const groupId = params.unsubscribe;
    if (groupId) {
      try {
        updateAfterLoad(await unsubscriptionApi.unsubscribe(groupId));
        createToastMessage(dispatch, {
          type: "success",
          message: i18n.t(`toasts.success.unsubscribed`, {
            group: i18n.t(
              `pages.settings.notifications.groups.${groupId}.title`
            ),
          }),
        });
      } catch (err) {
        /* Just ignoring this */
      }
    }
  }

  function updateAfterLoad({ groups }) {
    setNotifications(
      groups.map((group) => ({
        description: i18n.t(
          `pages.settings.notifications.groups.${group.id}.description`
        ),
        label: i18n.t(`pages.settings.notifications.groups.${group.id}.title`),
        value: group.id,
      }))
    );
    const values = groups
      .filter((group) => !group.unsubscribed)
      .map((group) => group.id);

    setGroups(groups);
    setValues(values);
    setLoadedValues(values);
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);
    setSending(true);

    const unsubscriptions = groups
      .filter((group) => !values.includes(group.id))
      .map((group) => group.id);

    try {
      updateAfterLoad(await unsubscriptionApi.update(unsubscriptions));
      createToastMessage(dispatch, {
        type: "success",
        message: i18n.t("pages.settings.notifications.successToast"),
      });

      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    } catch (err) {
      setError(err.errors);
    }
    setSending(false);
  }

  return (
    <section>
      <div class="row">
        <div class="col s12 l7 ml-0">
          <h2 class="t-h6 t-h6--margin">
            {i18n.t("pages.settings.notifications.title")}
          </h2>
          <h3 class="t-subtitle1 t-subtitle1--margin mb-0">
            {i18n.t("pages.settings.notifications.subtitle")}
          </h3>
        </div>
        <div class="col s12 l7 ml-0">
          <form onSubmit={handleSubmit} ref={formRef}>
            {error && <Alert error>{error}</Alert>}
            <CheckboxGroup
              items={notifications}
              value={values}
              onChange={(event) => {
                if (event.target.checked) {
                  setValues([...values, event.target.value]);
                } else {
                  setValues(values.filter((x) => x != event.target.value));
                }
              }}
            />

            <p class="mt-48">
              <SubmitButton
                sending={sending}
                success={success}
                disabled={
                  loadedValues.sort().join(",") == values.sort().join(",")
                }
              >
                {i18n.t("pages.settings.notifications.submit")}
              </SubmitButton>
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
